'use client';
import React from 'react';
import { tjtEditions } from '@/lib/publications/registry';

export default function EditionSwitcher({ currentPrefix }) {
  const handleSwitch = (e, edition) => {
    e.preventDefault();
    document.cookie = `tjt_preferred_edition=${edition.preferenceCode}; path=/; max-age=31536000; samesite=lax`;
    window.location.href = edition.prefix ? `/${edition.prefix}/` : '/';
  };

  return (
    <div className="absolute left-1/2 -translate-x-1/2 hidden md:flex space-x-4 lg:space-x-8 tracking-wide">
      {tjtEditions.map(edition => {
        const isActive = edition.prefix === currentPrefix || (!edition.prefix && !currentPrefix);
        return (
          <a
            key={edition.preferenceCode}
            href={edition.prefix ? `/${edition.prefix}/` : '/'}
            onClick={(e) => handleSwitch(e, edition)}
            className={`cursor-pointer transition-colors uppercase ${
              isActive ? 'font-bold text-black border-b border-black' : 'font-medium text-gray-500 hover:text-black hover:border-b hover:border-gray-300'
            }`}
          >
            {edition.name}
          </a>
        );
      })}
    </div>
  );
}
